module.exports = __webpack_public_path__ + "static/media/bg.628f6f20.jpg";